import gql from 'graphql-tag'

export const BOOKING = gql`
query ($id: Int!) {
    booking (id: $id){
      room {
        roomType {
          facility {
            id
          }      
        }    
      }
      checkInDate
      checkOutDate
      rentalItems {
        id
        unitPrice 
        quantity
        rentalPeriod
        fromDate
        toDate 
        rentalItem {
          id
          rentalItemDef {
            name
          }
        }
      }
    }
  }
`
export const ADD_RENTAL_ITEM_RESERVATION = `
mutation ($bookingId: Int!, $rentalItems: [AddReservationRentalItemInput!]!, $allowChargeDuplication: Boolean) {
  addRentalItemReservation(
    bookingId: $bookingId
    rentalItems: $rentalItems
    allowChargeDuplication: $allowChargeDuplication
  ) {
    __typename
  }
}
`

export const RENTAL_ITEM_LIST = gql`
query($facilityId: Int!) {
  rentalItemList(facilityId: $facilityId) {
    quantity
    id
    rentalItemDef{
      name
    }
  }
}
`

export const UPDATE_RENTAL_ITEM_RESERVATION_INPUT = `
mutation ($data: UpdateReservationRentalItemInput!, $allowChargeDuplication: Boolean) {
  updateRentalItemReservation(data: $data, allowChargeDuplication: $allowChargeDuplication) {
    __typename
  }
}
`

export const UPDATE_RENTAL_ITEM_RESERVATIONS = `
mutation (
  $bookingId: Int!
  $data: [UpdateReservationRentalItemInput!]!
  $allowChargeDuplication: Boolean
) {
  updateRentalItemReservations(
    bookingId: $bookingId
    data: $data
    allowChargeDuplication: $allowChargeDuplication
  )
}
`
